import { MyAccountRoute } from "@/constants/routes/myAccount"
import { isFeatureFlagOn } from "@/plugins/router/middleware/isFeatureFlagOn"
import { useQueryClient } from "@tanstack/vue-query"
import { NavigationGuard } from "vue-router"

export const moveWithUsRedirectGuard: NavigationGuard = async () => {
  if (await isFeatureFlagOn(useQueryClient(), "cotStayUpfront")) return

  return { path: MyAccountRoute.movingHome }
}
